<template>
<div>
<vue-snotify/>
<div v-if="isLoading" class="loading">Loading&#8230;</div>


<!-- NEW NOTE BUTTON  -->
<div class="columns is-gapless is-mobile  has-text-right" style="margin-bottom:0em;">
<div class="column is-10">&nbsp;</div>  
<div v-if="!note_add" class="column is-2 is-size-7 has-text-weight-bold">
    <button @click="note_add=!note_add" class="button is-size-7 is-small is-borderless is-fullwidth has-text-weight-bold has-background-primary-light has-text-grey"><span class="icon is-small has-text-right is-size-7"><i class="fas fa-edit"></i>&nbsp;&nbsp;&nbsp;AJOUTER UNE NOTE </span></button>
</div>
</div>
<!-- END NEW NOTE BUTTON  -->

<!-- NOTE ADD !!!!-->
<div v-show="note_add" class="columns is-mobile is-multiline box is-shadowless has-background-grey-dark">

<div class="column is-10">
    <div class="columns is-multiline is-gapless">
    <div class="column is-12 "><div class="field is-fullwidth"><div class="control"><textarea v-model="note_note" class="textarea is-size-5 has-text-weight-semibold" placeholder="Note...."></textarea></div></div></div>
    </div>
</div>

<div class="column is-2 box">
    <a class="button is-fullwidth has-background-success" @click="note_save()"> SAVE</a>  
    <br>
    <a class="button is-fullwidth has-background-grey-lighter has-text-black" @click="note_cancel()">CANCEL</a>
</div>
</div> 
<!-- END NOTE ADD !!!!-->

<div v-for="(note, index) in data_notes" :key="index">
<div class="columns is-gapless is-multiline has-background-white is-mobile" style="margin-bottom:2em;">


<div class="column is-12  is-size-6 has-text-left has-text-weight-bold has-background-white has-text-grey">
<span class=" is-size-7">&nbsp;&nbsp;Dat :</span>    &nbsp;{{ return_date(note.comment_DATE)}} &nbsp;&nbsp;&nbsp;&nbsp;
<span class=" is-size-7">Time :</span>    &nbsp;{{note.comment_TIME}} &nbsp;&nbsp;&nbsp;&nbsp;
<span class=" is-size-7">Par :</span>    &nbsp;{{ note.comment_STAFF }} 
&nbsp;&nbsp;&nbsp;&nbsp;
<button @click="note_delete_confirm(index)" class="button is-outlined is-small has-text-weight-bold has-background-danger-light has-text-danger" style="">
<span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span></button>  
</div>


<!-- <div class="column is-5 has-background-white"> &nbsp;</div> -->

<!-- <div class="column is-1">
<button @click="note_delete_confirm(index)" class="button is-outlined is-fullwidth is-small has-text-weight-bold has-background-danger-light has-text-danger" style="">
<span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span></button>         
</div> -->


<div class="column is-12 " style="">
<div class="columns is-gapless" style="padding:.5em;margin-bottom:.5em;">
<div class="column is-12 colNotes is-size-5 has-text-weight-semibold" style="white-space: pre;"> &nbsp;{{ note.comment_DESC }}</div>
</div>
</div>




<!-- <div class="column is-2 borderIt">  
<div class="columns is-gapless is-multiline">

<div class="column is-12">
<div class="columns is-gapless is-multiline">   
<div class="column is-6 is-uppercase has-text-weight-bold" style="margin-bottom:-.2em;">&nbsp;{{ return_date(note.comment_DATE)}}</div>

<div class="column is-6 is-size-7 has-text-right is-uppercase has-text-weight-bold" style="margin-bottom:-.2em;">{{note.comment_TIME}}&nbsp;</div>

<div class="column is-11 is-size-7 has-text-weight-bold has-text-info">&nbsp;{{ note.comment_STAFF }}</div>
<div class="column is-1">
<button @click="note_delete_confirm(index)" class="button  is-small has-text-weight-bold" style="color:LIGHTCORAL">
<span class="icon is-small has-text-left"><i class="fas fa-window-close"></i></span>     
</button>         
</div>
</div>            
</div>   
</div>
</div>

<div v-if="note.is_selected" class="column is-10 borderIt has-text-weight-semibold colNotes">  

<div class="columns is-gapless">

    <div class="column is-1">
        <button @click="note_delete_delete()" class="button is-fullwidth has-text-weight-bold" style="background-color:LIGHTCORAL;color:white">
            <span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     
        </button>
    </div>
    <div class="column is-11 has-text-grey-light colNotes" style="white-space: pre;">  &nbsp;{{ note.comment_DESC }}  </div>

</div>


</div>

<div v-else class="column is-10 borderIt is-size-5 has-text-weight-semibold has-text-grey-dark colNotes" style="white-space: pre;">  
    &nbsp;{{ note.comment_DESC }}
</div> -->



</div>
</div>
<!-- END NOTES LOOP  -->



</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment';

export default {
  props: [ 'student_id'  ],
  
  data() {
      return {
is_visible:true,
isLoading:false,
show_all:false,
 
            note_id:0,
            note_index:-1,
            note_note:'',
            note_user: sessionStorage.getItem('user_name'),
            note_add:false,

data_notes:[],

note_delete_show:false,

      }
  },

created() {
    this.notes_get()
},


methods: {

note_delete_confirm:function(index) {
    // this.note_index = index 
    // this.data_notes[index].is_selected = !this.data_notes[index].is_selected
    this.$snotify.confirm('DELETE COMMENT ?', { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "rightCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.note_delete_delete(toast,index)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]  });
},

note_delete_delete:function(toast,index) {
this.$snotify.remove(toast.id)

    var query = "DELETE FROM MyMEQ_STUDENT_COMMENTS WHERE comment_ID = " + this.data_notes[index].comment_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(response => { 
        this.notes_get()
    })

},


return_date:function(dt) {
    return moment(dt).add(1, 'days').format('DD-MMM YY')
},


// GET THE NOTES
notes_get:function() {
    this.isLoading = false;
    var query = "SELECT MyMEQ_STUDENT_COMMENTS.*,  0 AS is_selected FROM MyMEQ_STUDENT_COMMENTS WHERE student_ID = " + this.student_id + " ORDER BY comment_ID DESC" //+ " AND prodStatus_DESC = '" + this.status + "'"
    
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(response => {
        this.data_notes = response.data 
        this.isLoading = false;
    })

}, // END GET NOTES



note_click:function(index) {
/*   this.note_index = index
  this.note_id = this.notes[index].note_id
  this.note_type = this.notes[index].note_type
  this.note_note= this.notes[index].note_note
  this.note_add = true  */
},


note_cancel:function() {
// JUST CLOSE 
  this.note_add = false
  this.note_index = -1
  this.note_id = 0
  this.note_note = ''

},

/* 
approval_delete:function() {
        axios.post(this.$url+'/approval_delete?id='+ this.inID +'&appid='+ this.note_id)        
        .then(response =>{ })
        .catch(e => { console.log(e)})
        //REMOVE FROM ARRAY
        this.notes.splice(this.note_index, 1);
        this.note_cancel() //CLOSE UP
}, */


// SAVE THE NOTES !!!! 
  note_save:function() {


//ALWAYS INSERT !
var tm = new Date().toLocaleTimeString();
var query = "INSERT INTO MyMEQ_STUDENT_COMMENTS (student_ID ,comment_STAFF, comment_DATE, comment_time, comment_DESC)  VALUES ( "
query +=  this.student_id + ",'" + sessionStorage.getItem('user_name') +  "','" + this.get_date() + "','" + tm + "','" + this.note_note.replace(/'/g,"''") + "');" 



console.log(query)

    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(response => { 
        this.note_cancel()
        this.notes_get()
    })

 

    
    }, // END SAVE 


    inDays_diff: function(dt1,dt2,done) {
        // GET DAYS SINCE ....
        if(done == true) {
        var d1 = new Date(dt1);
        var d2 = new Date(dt2);
        var t2 = d1.getTime();
        var t1 = d2.getTime();
        return Math.abs(parseInt((t2-t1)/(24*3600*1000)));

        } else {
            return '-'
        }

    },
    inDays: function(dt) {
        // GET DAYS SINCE ....
        var d1 = new Date(dt);
        var d2 = new Date();
        var t2 = d1.getTime();
        var t1 = d2.getTime();
        return Math.abs(parseInt((t2-t1)/(24*3600*1000)));
    },
    get_date: function() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) { dd = '0' + dd;}
        if (mm < 10) {mm = '0' + mm;}
        return  yyyy + '-' + mm + '-' + dd;
    },
// GENERATE A NEW ID! 
    randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},

}

}
</script>

<style scoped>

a {
    color:inherit;
}
.isLabelHeader{
    font-size:80%;
    font-weight: 900;
    color:#732B34;  
}
.columnNoWrap {
    white-space: nowrap;
    overflow: hidden;
}

.borderIt {
  border: 1px solid  darkgray;
  padding:2px;
}
.margeBottomLess{
  margin-bottom: -14px;
}
</style>
